import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/layout/Layout'
import LandingPage from '@/components/pages/LandingPage'
import Video from '@/components/pages/Video'
import VideoMap from '@/components/pages/VideoMap'

Vue.use(Router)

export default new Router({
    base: process.env.ROUTER_BASE,
    mode: 'history',
    routes: [
        {
            path: '/',
            // Remove route name:
            // Named Route 'Layout' has a default child route. When navigating to this named route (:to="{name: 'Layout'"),
            // the default child route will not be rendered. Remove the name from this route and use the name of the
            // default child route for named links instead.
            component: Layout,
            children: [
                {
                    path: '/',
                    name: 'LandingPage',
                    component: LandingPage
                },
                {
                    path: 'video/:year/:type/:videoId',
                    name: 'Video',
                    component: Video,
                    props: true
                },
                {
                    path: 'map/:year/:type',
                    name: 'VideoMap',
                    component: VideoMap,
                    props: true
                }
            ]
        },
        {
            path: '*',
            redirect: '/'
        }
    ],
    methods :{

    }
})



// WEBPACK FOOTER //
// ./src/plugins/router.js